function showShearCheckSummary() {
    var design = activeProject.design;
    var checks = g_results["shear_checks"];
    var controlling_unity = checks["controlling_unity"];
    var controlling_case = checks["controlling_case"];
    var controlling_Vu = checks["controlling_Vu"];
    var controlling_Vn = checks["controlling_Vn"];
    var controlling_equation = checks["controlling_code_equation"];
    var controlling_case = checks["controlling_case"];
    var controlling_location = checks["controlling_loc"];
    
    const nice_eq_index = Number(controlling_case.split('EQ')[1])

    var nice_case = design.loadCombination["prettyEquations"][nice_eq_index-1]["EQ"];
    var success = controlling_unity < 1.0;
    var designStatusStr = success ? '<i class="fa-solid fa-check text-success"></i>' : '<i class="fa-solid fa-xmark text-danger"></i>';
    setDesignPanelSuccessOrFail(success, '#shear-design-panel');

    var str = '<div class="card-header">';
    str += '<h4 class="panel-title"><span class="float-start">';
    str += designStatusStr + ' Shear</span><span class="float-end">' + controlling_unity.toFixed(2) + '</span></h4></div>';

    str += "<table class='table'>";

    if(activeProject.isEngineeredLumber) {
        str += makeSummaryRow('Vu (Demand)', `${showBigPointLoad(controlling_Vu)} ${bigPointLoadUnit()}`)
    } else if(activeProject.isNorthAmericanSteel || design.designType === 'None') {
        str += makeSummaryRow((activeProject.isASD) ? "Vr (Demand)" : "Vu (Demand)", `${showBigPointLoad(controlling_Vu)} ${bigPointLoadUnit()}`)
        str += makeSummaryRow((activeProject.isASD) ? "Vn/&Omega; (Capcity)" : "&Phi;Vn (Capacity)", `${showBigPointLoad(controlling_Vn)} ${bigPointLoadUnit()}`)
    } else {
        // note our wood design checks are actually returning shear stress not
        // shear force
        str += makeSummaryRow('fv (Demand)', `${Number(controlling_Vu).toFixed(2)} psi`)
        str += makeSummaryRow("F'v (Capacity)", `${Number(controlling_Vn).toFixed(2)} psi`)
    }

    let label = 'Controlling Equation'
    let value = controlling_equation

    if(activeProject.isEngineeredLumber) {    
        value = "Vu &le; Vn"
    } else if(activeProject.isFormTechShape) {
        value = controlling_equation
    } else if(activeProject.isNoDesign) {
        value = "Vn = Fy &bull; A &bull; 0.6";
    } 
    
    str += makeSummaryRow(label, value)

    str += makeSummaryRow('Location', showLengthWithUnits(controlling_location))

    str += makeSummaryRow('Load Combination', nice_case)
    
    str += "</table>";

    document.getElementById('shear-design-panel').innerHTML = str
}
